export class SourceAccount {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerAccountName",
            "baseName": "providerAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "AccountState",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "AccountVersion",
            "format": ""
        },
        {
            "name": "connectedTime",
            "baseName": "connectedTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "sourceAccountAttributes",
            "baseName": "sourceAccountAttributes",
            "type": "SourceAccountCloudAttributes",
            "format": ""
        },
        {
            "name": "isJobMetricsEnabled",
            "baseName": "isJobMetricsEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "alias",
            "baseName": "alias",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceAccount.attributeTypeMap;
    }
    constructor() {
    }
}
